import { useQuery } from "react-query";
import { getFileCategories } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useFileCategories = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetFileCategories",
    getFileCategories,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
